__turbopack_context__.v({
  "accordionSlideOverwrite": "expandableText-module-scss-module__BCdc8W__accordionSlideOverwrite",
  "chevron": "expandableText-module-scss-module__BCdc8W__chevron",
  "description": "expandableText-module-scss-module__BCdc8W__description",
  "expanded": "expandableText-module-scss-module__BCdc8W__expanded",
  "fadeIn": "expandableText-module-scss-module__BCdc8W__fadeIn",
  "fadeOut": "expandableText-module-scss-module__BCdc8W__fadeOut",
  "lg": "expandableText-module-scss-module__BCdc8W__lg",
  "md": "expandableText-module-scss-module__BCdc8W__md",
  "readMoreButton": "expandableText-module-scss-module__BCdc8W__readMoreButton",
  "scaleIn": "expandableText-module-scss-module__BCdc8W__scaleIn",
  "scaleOut": "expandableText-module-scss-module__BCdc8W__scaleOut",
  "sm": "expandableText-module-scss-module__BCdc8W__sm",
  "text": "expandableText-module-scss-module__BCdc8W__text",
  "xl": "expandableText-module-scss-module__BCdc8W__xl",
  "zoomIn": "expandableText-module-scss-module__BCdc8W__zoomIn",
  "zoomOut": "expandableText-module-scss-module__BCdc8W__zoomOut",
});
